const EMAIL_REGEX = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
const LONG_NUMBER_REGEX = /\b\d{6,}\b/g;

const normalizeWhitespace = (value: string) => value.replace(/\s+/g, " ").trim();

const redactSensitive = (value: string) =>
  value.replace(EMAIL_REGEX, "[redacted-email]").replace(LONG_NUMBER_REGEX, "[redacted-number]");

const clamp = (value: string, maxLen: number) => value.slice(0, maxLen);

export const normalizeErrorName = (err: unknown): string => {
  if (err instanceof Error && err.name) return err.name;
  return "Error";
};

export const sanitizePathname = (pathname: string): string => {
  if (!pathname) return "/";
  const segments = pathname.split("/").map((segment) => {
    if (segment === "") return "";
    if (/^[0-9]{4,}$/.test(segment)) return ":id";
    if (/^[0-9a-fA-F-]{8,}$/.test(segment)) return ":id";
    if (segment.length > 32) return ":id";
    return segment;
  });
  const sanitized = segments.join("/");
  return sanitized.startsWith("/") ? sanitized : `/${sanitized}`;
};

export const sanitizeErrorMessage = (value: unknown, maxLen = 200): string => {
  if (value == null) return "";
  const text = typeof value === "string" ? value : String(value);
  return clamp(redactSensitive(normalizeWhitespace(text)), maxLen);
};

export const sanitizeErrorStack = (value: unknown, maxLen = 1000): string | undefined => {
  if (!value) return undefined;
  const text = typeof value === "string" ? value : String(value);
  const sanitized = clamp(redactSensitive(text), maxLen);
  return sanitized.length > 0 ? sanitized : undefined;
};
